// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8f07792f","453":"65c29478","732":"158ca81c","952":"ae50bb7c","977":"3daa2350"}[chunkId] + ".chunk.js";
};